import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { lighten, makeStyles } from "@material-ui/core/styles";
// import AlertComponent from "../../../../_metronic/_helpers/AlertComponent";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import EyeIcon from "@material-ui/icons/RemoveRedEye";
import EditIcon from "@material-ui/icons/Edit";
import PlusIcon from "@material-ui/icons/Add";
import CircularProgress from "@material-ui/core/CircularProgress/index";
import StatusButton from "../../../../_metronic/_helpers/StatusButton";
import { RiFileExcel2Fill } from "react-icons/ri";
import LockIcon from "@material-ui/icons/Lock";


const headRows = [
  {
    id: "Asset.Name",
    numeric: false,
    disablePadding: true,
    label: "Asset name",
  },
  {
    id: "User.FirstName",
    numeric: false,
    disablePadding: true,
    label: "Full name",
  },
  {
    id: "User.Email",
    numeric: false,
    disablePadding: true,
    label: "Email",
  },
  {
    id: "User.Phone",
    numeric: false,
    disablePadding: true,
    label: "Phone",
  },
  { id: "status", numeric: false, disablePadding: true, label: "Status" },

  { id: "tools", numeric: false, disablePadding: true, label: "Actions" },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "Select all desserts" }}
          />
        </TableCell>
        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? "right" : "left"}
            padding={row.disablePadding ? "none" : "default"}
            sortDirection={orderBy === row.id ? false : false}
          >
            <TableSortLabel
              active={orderBy === row.id}
              direction={order ? "asc" : "desc"}
              onClick={() => {
                return row.id !== "tools" ? onRequestSort(row.id) : null;
              }}
            >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.bool.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
    display: "flex",
  },
  title: {
    flex: "0 0 auto",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const {
    numSelected,
    setOpenCreate,
    onDeleteHumanResources,
    onHumanResourcesExport,
  } = props;

  return (
    <Toolbar
      className={clsx(classes.root, classes.toolbar, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 && (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 && (
          <Tooltip title="Delete">
            <IconButton   className="mr-2 "  aria-label="Delete" onClick={onDeleteHumanResources}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title="Export" placement="top">
          <button
            aria-label="Add balance"
            className="flex-shrink-0 btn btn-sm btn-icon btn-bg-light btn-text-info btn-hover-info mr-2 h5 rounded-circle flex-shrink-0"
            onClick={onHumanResourcesExport}
          >
            <RiFileExcel2Fill />
          </button>
        </Tooltip>
      </div>
      <Tooltip title="Create" placement="top">
        <button
          className="btn flex-shrink-0 btn-sm btn-icon btn-bg-light btn-text-primary btn-hover-primary mr-2 h5 rounded-circle"
          onClick={() => setOpenCreate(true)}
        >
          <PlusIcon />
        </button>
      </Tooltip>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  toolbar: {
    minHeight: theme.spacing(2),
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#63C059",
  },
}));

export default function EnhancedTable(props) {
  const {
    setSortField,
    setOrderByTable,
    sortField,
    orderBy,
    setOpenEdit,
    setOpenRemove,
    setOpenView,
    setOpenCreate,
    setOpenChangePassword,

    isLoaded,
    error,
    rows,
    onHumanResourceChoose,
    onUpdateUserStatus,
    updateSkip,
    updateTake,
    count,
    setHumanResourceId,
    setDeleteHumanResourcesID,
    deleteHumanResourcesIds,
    onDeleteHumanResources,
    onHumanResourcesExport,
  } = props;
  const classes = useStyles();

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  function handleRequestSort(property) {
    const isDesc = sortField === property && !orderBy;

    setOrderByTable(isDesc);
    setSortField(property);
    updateTake(10);
    setRowsPerPage(10);
    updateSkip(0);
    setPage(0);
  }

  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);

      setDeleteHumanResourcesID(newSelecteds);
      return;
    }

    setDeleteHumanResourcesID([]);
  }

  function handleClick(event, id) {
    const selectedIndex = deleteHumanResourcesIds.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(deleteHumanResourcesIds, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(deleteHumanResourcesIds.slice(1));
    } else if (selectedIndex === deleteHumanResourcesIds.length - 1) {
      newSelected = newSelected.concat(deleteHumanResourcesIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        deleteHumanResourcesIds.slice(0, selectedIndex),
        deleteHumanResourcesIds.slice(selectedIndex + 1)
      );
    }

    setDeleteHumanResourcesID(newSelected);
  }

  function handleChangePage(event, newPage) {
    setPage(newPage);
    updateSkip(newPage * rowsPerPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    updateTake(+event.target.value);
    setPage(0);
    updateSkip(0);
  }

  const isSelected = (id) => deleteHumanResourcesIds.indexOf(id) !== -1;

  return (
    <div className="col-12 col-12-table">
      <div className={classes.root}>
        <Paper className={classes.paper}>
          {isLoaded && !rows.length && (
            <div className={classes.progresRoot}>
              <CircularProgress className={classes.progress} />
            </div>
          )}
          <EnhancedTableToolbar
            numSelected={deleteHumanResourcesIds.length}
            setOpenCreate={setOpenCreate}
            onDeleteHumanResources={onDeleteHumanResources}
            onHumanResourcesExport={onHumanResourcesExport}
          />
          <div className={classes.tableWrapper}>
            {rows.length ? (
              <Table className={classes.table} aria-labelledby="tableTitle">
                <EnhancedTableHead
                  numSelected={deleteHumanResourcesIds.length}
                  order={orderBy}
                  orderBy={sortField}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                />
                <TableBody>
                  {rows.map((row, index) => {
                    const isItemSelected = isSelected(row.id);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.id}
                        selected={isItemSelected}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={isItemSelected}
                            inputProps={{ "aria-labelledby": labelId }}
                            onChange={(event) => handleClick(event, row.id)}
                          />
                        </TableCell>
                        {/* <TableCell padding="none" className="pr-4">
                          {row.assetId}
                        </TableCell> */}
                        <TableCell padding="none" className="pr-4">
                          {row.assetName}
                        </TableCell>
                        <TableCell padding="none" className="pr-4">
                          {row.firstName} {row.lastName}
                        </TableCell>
                        <TableCell padding="none" className="pr-4">
                          {row.email}
                        </TableCell>
                        <TableCell padding="none" className="pr-4">
                          {row.phone}
                        </TableCell>
                        <TableCell padding="none" className="pr-4">
                        <StatusButton
                              id={row.id}
                              isActive={row.isActive}
                              onUpdateUserStatus={onUpdateUserStatus}
                            />
                      </TableCell>
                        <TableCell padding="none" className="pr-4">
                     
                          <Tooltip title="View" placement="top">
                            <button
                              aria-label="view"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-info btn-hover-info mr-2"
                              onClick={(e) => {
                                setOpenView(e);
                                onHumanResourceChoose(row.id);
                              }}
                            >
                              <EyeIcon />
                            </button>
                          </Tooltip>

                          <Tooltip title="Edit" placement="top">
                            <button
                              aria-label="edit"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-dark btn-hover-dark mr-2"
                              onClick={() => {
                                setOpenEdit(true);
                                onHumanResourceChoose(row.id);
                              }}
                            >
                              <EditIcon />
                            </button>
                          </Tooltip>
                          <Tooltip title="Change password" placement="top">
                            <button
                              aria-label="changePassword"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-warning btn-hover-warning mr-2"
                              onClick={() => {
                                setOpenChangePassword(true);
                                setHumanResourceId(row.id);
                              }}
                            >
                              <LockIcon />
                            </button>
                          </Tooltip>
                          <Tooltip title="Delete" placement="top">
                            <button
                              aria-label="Delete"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-danger btn-hover-danger"
                              onClick={() => {
                                setOpenRemove(true);
                                setHumanResourceId(row.id);
                              }}
                            >
                              <DeleteIcon />
                            </button>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            ) : !rows.length && !isLoaded && !error ? (
              // <AlertComponent variant="info" message="No information found" />
              <div className="noInfo"><img src="./media/error/search2.png" alt="information" />
              <h4>No information found</h4></div>
            ) : (
              !isLoaded &&
              error && (
                // <AlertComponent
                //   variant="danger"
                //   message="We've lost the connection"
                // />
                <div className="noInfo"><img src="./media/error/connection.png" className="info-img" alt="connection" />
                <h4>We've lost the connection</h4></div>
              )
            )}
          </div>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              backIconButtonProps={{
                "aria-label": "Previous Page",
              }}
              nextIconButtonProps={{
                "aria-label": "Next Page",
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Paper>
      </div>
    </div>
  );
}
